import React, { useState } from 'react';
import { Form, Modal } from '@douyinfe/semi-ui';
import ColorPicker from '../../../ColorPicker';

export const SingleTextStyleForm = ({ data = {}, onChange }) => {
    const [visible, setVisible] = useState(false);
    const defaultData = {
        text: '文本内容',
        style: {
            fontSize: '16px',
            color: '#1C1F23',
            textAlign: 'left',
            backgroundColor: '#ffffff'
        }
    };

    const handleStyleChange = (field, value) => {
        const newData = {
            ...defaultData,
            ...data,
            style: {
                ...(data.style || defaultData.style),
                [field]: typeof value === 'number' ? `${value}px` : value
            }
        };
        onChange?.(newData);
    };

    const parseStyleValue = (value) => {
        if (value === undefined || value === null) return null;
        if (typeof value === 'string') {
            const match = value.match(/^(\d+)px$/);
            return match ? parseInt(match[1]) : value;
        }
        return value;
    };

    const renderStyleForm = () => (
        <Form labelPosition="left" labelAlign="right" initValues={{
            text: data?.text || defaultData.text,
            fontSize: parseStyleValue(data?.style?.fontSize) || 16,
            color: data?.style?.color || defaultData.style.color,
            textAlign: data?.style?.textAlign || defaultData.style.textAlign
        }} onValueChange={(values) => {
            const newData = {
                ...defaultData,
                ...data,
                text: values.text,
                style: {
                    ...(data.style || defaultData.style),
                    fontSize: `${values.fontSize}px`,
                    textAlign: values.textAlign,
                    //color: values.color,
                    //backgroundColor: values.backgroundColor
                }
            };
            onChange?.(newData);
        }}>
            <Form.Input
                field="text"
                label="文本内容"
            />
            <Form.Section text="文本样式">
                <Form.InputNumber
                    field="fontSize"
                    label="字体大小"
                    suffix="px"
                />
                <Form.Slot label="字体颜色">
                    <ColorPicker
                        field="color"
                        value={data?.style?.color || defaultData.style.color}
                        onChange={(value) => handleStyleChange('color', value)}
                    />
                </Form.Slot>
                <Form.Slot label="背景颜色">
                    <ColorPicker
                        field="backgroundColor"
                        value={data?.style?.backgroundColor || defaultData.style.backgroundColor}
                        onChange={(value) => handleStyleChange('backgroundColor', value)}
                    />
                </Form.Slot>
                <Form.Select
                    field="textAlign"
                    label="对齐方式"
                    style={{ width: '100%' }}
                >
                    <Form.Select.Option value="left">左对齐</Form.Select.Option>
                    <Form.Select.Option value="center">居中对齐</Form.Select.Option>
                    <Form.Select.Option value="right">右对齐</Form.Select.Option>
                </Form.Select>
            </Form.Section>
        </Form>
    );

    return (
        <div>
            <div
                onClick={() => setVisible(true)}
                style={{
                    cursor: 'pointer',
                    padding: '8px',
                    border: '1px dashed var(--semi-color-border)',
                    borderRadius: '4px',
                    fontSize: data?.style?.fontSize || defaultData.style.fontSize,
                    color: data?.style?.color || defaultData.style.color,
                    textAlign: data?.style?.textAlign || defaultData.style.textAlign,
                    backgroundColor: data?.style?.backgroundColor || defaultData.style.backgroundColor
                }}
            >
                {data?.text || defaultData.text}
            </div>
            <Modal
                title="编辑文本"
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={null}
                width={500}
                centered
            >
                {renderStyleForm()}
            </Modal>
        </div>
    );
};

export default SingleTextStyleForm;